import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_PAAPI_PREBID_MODULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updatePaapiPrebidModule($input: UpdatePaapiPrebidModuleInput!) {
    updatePaapiPrebidModule(input: $input) {
      workspacePrebidModule {
        id
        enabled
        params
        workspaceBidderIds
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
